import { createEnumMap } from 'Commons/helpers/utils/Formatter';

const formatter = label => label.replace(/([A-Z])/g, match => `_${match}`).toUpperCase();

const MAINTENANCE_EVENTS_PERMISSION_KEYS = createEnumMap(['closeEvent', 'cancelEvent'], formatter);

export default MAINTENANCE_EVENTS_PERMISSION_KEYS;
